export default "__VITE_ASSET__3gjMbCQ3__"